module.exports = __webpack_public_path__ + "static/media/23.277937b6.jpeg";